module.exports = __webpack_public_path__ + "static/img/ex04.b54c00f2.png";